export default function getB2BRoute(path: string) {
  const isDev = process.env.NODE_ENV === 'development'
  return isDev ? `/b2b${path}` : path
}
